/**
 * Created by renjie.huang on 2017/9/25.
 */

import "v4-style";
import "v4-icon";
import "common-style";
import React from "react";
import ReactDOM from "react-dom";
import gtInit from './common/gt';
import MobileDetect from "mobile-detect";

import App from "./App.jsx";

import { deviceInit } from './service/deviceDetectService'

deviceInit();

let app = document.getElementById("app");

ReactDOM.render(React.createElement(App), app);
let skeleton = document.querySelector('div[data-console-skeleton-wrapper]')
document.getElementsByTagName('body')[0].removeChild(skeleton)



// WEBPACK FOOTER //
// ./src/index.js